import * as React from 'react'

import './LoadingEllipsis.scss'

const LoadingEllipsis = (props) => {
  const { customised } = props
  const CustomEllipsis = () => {
    return (
      <div data-testid="loading-ellipsis" className="loadingEllipsis">
        <div style={{ height: '20px' }} className="lds-ellipsis">
          <div style={{ top: '5px', width: '9px', height: '9px' }} />
          <div style={{ top: '5px', width: '9px', height: '9px' }} />
          <div style={{ top: '5px', width: '9px', height: '9px' }} />
          <div style={{ top: '5px', width: '9px', height: '9px' }} />
        </div>
      </div>
    )
  }

  const DefaultEllipsis = () => {
    return (
      <div data-testid="loading-ellipsis" className="loadingEllipsis">
        <div className="lds-ellipsis">
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    )
  }
  return customised ? <CustomEllipsis /> : <DefaultEllipsis />
}

export default LoadingEllipsis
